"use strict";

exports.__esModule = true;
var _DeviceDetailsDataProvider = require("./DeviceDetailsDataProvider");
Object.keys(_DeviceDetailsDataProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsDataProvider[key]) return;
  exports[key] = _DeviceDetailsDataProvider[key];
});
var _DeviceDetailsURLFilter = require("./DeviceDetailsURLFilter");
Object.keys(_DeviceDetailsURLFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceDetailsURLFilter[key]) return;
  exports[key] = _DeviceDetailsURLFilter[key];
});
var _getDeviceDetailsWidgets = require("./getDeviceDetailsWidgets");
Object.keys(_getDeviceDetailsWidgets).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDeviceDetailsWidgets[key]) return;
  exports[key] = _getDeviceDetailsWidgets[key];
});